import * as actions from "@/AppRedux/actions/hotelProfile/hotelType";
import { ProcessType, HotelProfileState, HotelSettings } from "@/AppRedux/actions/hotelProfile/hotelType";

export const processInitialState: ProcessType = {
  status: false,
  action: undefined,
  message: undefined,
};

export const defaultHotelSettings: HotelSettings = {
  languages: ["en", "th"],
  theme_code: "default",
  allow_extrabed: true,
  deposit_payment_code: undefined,
  payment_timeout_min: 15,
  timeout_booking_status: "W",
  default_search_guests: null,
  gallery_mode: "slide",
  create_payment_link: false,
  booking_cutoff_enabled: false,
  booking_cutoff_time: null,
};

export const initialState: HotelProfileState = {
  loading: false,
  dataSource: null,
  hotelSettings: defaultHotelSettings,
  paymentCodeLoading: false,
  paymentCodeOptions: [],
  channelLoading: false,
  channelOptions: [],
  process: { status: false, action: null, message: null },
  propCode: null
};

export default function hotelProfileReducer(
  state: HotelProfileState = initialState,
  action: actions.HotelProfileAction
): HotelProfileState {
  switch (action.type) {
    case actions.HOTEL_PROP_REQUEST:
      return { ...state, loading: true, process: processInitialState };
    case actions.HOTEL_PROP_SUCCESS:
      return { ...state, 
                loading: false, 
                dataSource: action.payload  
              };
    case actions.HOTEL_SETTINGS_SUCCESS:
      return { ...state, hotelSettings: action.payload };
    case actions.HOTEL_PAYMENT_CODE_LIST_REQUEST:
      return { ...state, paymentCodeLoading: true };
    case actions.HOTEL_PAYMENT_CODE_LIST_SUCCESS:
      return { ...state, paymentCodeLoading: false, paymentCodeOptions: action.payload };
    case actions.HOTEL_PAYMENT_CODE_LIST_FAILURE:
      return { ...state, paymentCodeLoading: false, paymentCodeOptions: [] };
    case actions.HOTEL_SET_PROP_CODE:
      return { ...state, propCode: action.payload };
    case actions.HOTEL_PROP_PROCESS_STATUS:
      return { ...state, loading: false, process: action.payload };
    case actions.HOTEL_PROP_RESET:
      return { ...initialState };
    case actions.HOTEL_SETTING_UPDATE_REQUEST:
      return { ...state, loading: true, process: processInitialState };
    case actions.HOTEL_SETTING_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        hotelSettings: action.payload,
        process: {
          status: true,
          action: "HOTEL_SETTING_UPDATE",
          message: "Settings updated successfully",
        },
      };
    case actions.HOTEL_SETTING_UPDATE_FAILURE:
      return {
        ...state,
        loading: false,
        process: {
          status: false,
          action: "HOTEL_SETTING_UPDATE",
          message: action.payload,
        },
      };
    case actions.HOTEL_PROFILE_CLEAR_PROCESS:
      return { ...state, process: processInitialState };
    case actions.HOTEL_CHANNEL_LIST_REQUEST:
      return { ...state, channelLoading: true };
    case actions.HOTEL_CHANNEL_LIST_SUCCESS:
      return { ...state, channelLoading: false, channelOptions: action.payload };
    case actions.HOTEL_CHANNEL_LIST_FAILURE:
      return { ...state, channelLoading: false, channelOptions: [] };
    default:
      return state;
  }
}
